import { lighten } from 'polished'
import styled, { css } from 'styled-components'

import { ButtonAsync, muiRipple, type StyledCssProps } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	type?: 'default' | 'dark'
	size?: 'default' | 'small'
}

export const solidStyle = css<Props>`
	color: ${({ theme, type }) => (type === 'dark' ? theme.color.textContrast : theme.color.text)};
	background-color: ${({ theme, type }) => (type === 'dark' ? theme.color.secondary : theme.color.primary)};
	-webkit-font-smoothing: antialiased;
	font-family: ${helpers.font.family.header};
	font-size: ${({ theme, size }) => (size === 'small' ? theme.font.size.base : theme.font.size.large)};
	font-weight: 400;
	line-height: 1.5;
	border-radius: 64px;
	min-width: 200px;
	max-width: 100%;
	min-height: ${({ size }) => (size === 'small' ? '36px' : '46px')};
	padding-left: ${({ size }) => (size === 'small' ? '16px' : '24px')};
	padding-right: ${({ size }) => (size === 'small' ? '16px' : '24px')};
	transition: color 150ms, background-color 150ms;
	isolation: isolate;
	margin: 0;

	&:is(:focus-visible, :hover) {
		background-color: ${({ theme, type }) => (type === 'dark' ? lighten(0.05, theme.color.secondary) : theme.color.primaryLight)};
	}

	&:focus-visible {
		outline: 2px solid ${helpers.color.link};
		outline-offset: -2px;
	}

	&:disabled {
		background-color: ${helpers.color.disabledContrast};
		color: ${helpers.color.disabled};
	}

	${muiRipple()}

	.label {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 6px;
	}
`

export const ButtonSolid = styled(ButtonAsync)<StyledCssProps<typeof solidStyle>>`
	${solidStyle}
`
